import React from 'react';
import { Table, TableRow, TableHeaderCell } from 'semantic-ui-react';

export default function FertilizerPrintWorksheetBlocksTableHeader(): React.ReactElement {
    return (
        <Table.Header>
            <TableRow>
                <TableHeaderCell>Orchard</TableHeaderCell>
                <TableHeaderCell>Blocks</TableHeaderCell>
            </TableRow>
        </Table.Header>
    );
}
